import axios from 'axios'
// import QS from 'qs'
import store from '../src/store/index.js'
import router from '../src/router/index.js'
// import qs from 'qs'
if (process.env.NODE_ENV == 'development') {//eslint-disable-line
  // axios.defaults.baseURL = 'http://127.0.0.1:9099/sj'
  // axios.defaults.baseURL = 'http://125.64.210.26:9099/sj'
  // axios.defaults.baseURL = 'http://117.172.164.150:9099/sj'
  axios.defaults.baseURL = 'https://api.xwxzyyy.cn/sj'
} else if (process.env.NODE_ENV == 'debug') {//eslient-disable-line
  // axios.defaults.baseURL = 'http://125.64.210.26:9099/sj'
  // axios.defaults.baseURL = 'http://117.172.164.150:9099/sj'
  axios.defaults.baseURL = 'https://api.xwxzyyy.cn/sj'
} else {
  axios.defaults.baseURL = 'https://api.xwxzyyy.cn/sj'
  // axios.defaults.baseURL = 'http://117.172.164.150:9099/sj'
  // axios.defaults.baseURL = 'http://125.64.210.26:9099/sj'
}
// 请求超时时间
axios.defaults.timeout = 100000
// post 请求头
// axios.defaults.headers['Content-Type'] = 'application/json; charset=utf-8'
axios.defaults.headers['token'] = sessionStorage.getItem('token')
axios.defaults.headers['Content-Type'] = 'application/json; charset=utf-8'
// axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// 先导入vuex,因为我们要使用到里面的状态对象
// vuex的路径根据自己的路径去写
// 请求拦截器
axios.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem('token')
    token && (config.headers.Authorization = token)
    return config
  },
  error => {
    return Promise.error(error)
  })
axios.interceptors.response.use(
  response => {
    if (response.data.code == 200) {//eslint-disable-line
      return Promise.resolve(response)
    } else {
      return Promise.resolve(response)
    }
  },
  error => {
    if (error.response.data.code) {
      switch (error.response.data.code) {
        case 401:
          alert('登录已经过期，请重新登录')
          sessionStorage.removeItem('token')
          router.replace({
            path: '/login',
            query: { redirect: router.currentRoter.fullpath }
          })
          break
        case 403:
          alert('登录已经过期，请重新登录')
          sessionStorage.removeItem('token')
          store.commit('getToken', null)
          setTimeout(() => {
            router.replace({
              path: '/login',
              query: {
                redirect: router.currentRoute.fullPath
              }
            })
          }, 2000)
          break
        case 404:
          alert('请求不存在')
          break
        default:
          alert(error.response.data.msg)
      }
      return Promise.reject(error.response)
    }
  }
)
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
export function deleteUrl (url, params) {
  return new Promise((resolve, reject) => {
    axios.delete(url, {
      params: params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
export function post (url, data) {
  return new Promise((resolve, reject) => {
    axios.post(url, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
